import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaBancosPagos', NominasNominaBancosPagos)

function NominasNominaBancosPagos($api, $schema, $q) {
  this.get = get
  this.update = update
  this.remove = remove
  this.validarPagos = validarPagos

  function get(idEmpresa, idNomina) {
    return $api.get('/kendu/nominas/nomina/pagos', {
        idEmpresa: idEmpresa,
        idNomina: idNomina,
      }, {cache: 'nominas'})
      .then(function (data) {
        angular.forEach(data, function (empleados, idEmpresa) {
          angular.forEach(empleados, function (pagos, idEmpleado) {
            data[idEmpresa][idEmpleado] = pagos.map(function (item) {
              return format(item)
            })
          })
        })

        return data
      })
  }

  function remove(idNomina, idEmpresa, idEmpleado, indice) {
    return $api.post2('kendu/nominas/nomina/pagos/eliminar', {
      idNomina: idNomina,
      idEmpresa: idEmpresa,
      idEmpleado: idEmpleado,
      indice: indice,
    }, {}, {clearCache: 'nominas'})
  }

  function update(idNomina, idEmpresa, idEmpleado, indice, data) {
    return $api.update('kendu/nominas/nomina/pagos/actualizar', {
        idNomina: idNomina,
        idEmpresa: idEmpresa,
        idEmpleado: idEmpleado,
        indice: indice,
      }, format(data, true), {clearCache: 'nominas'})
      .then(function (data) {
        return format(data)
      })
  }

  function validarPagos(idEmpresa, idNomina, referencia, data) {
    return $api.update('kendu/nominas/nomina/pagos/validar', {
        idNomina: idNomina,
        idEmpresa: idEmpresa,
        referencia: referencia,
      }, format(data, true), {clearCache: 'nominas'})
      .then(function (result) {
        return result === 'OK' ? 'Su información ha sido actualizada.' : $q.reject(result)
      })
  }

  function format(data, reverse) {
    return $schema(data, {
      Importe: 'number',
      Tipo_Cambio: 'number',
      Captura_Fecha: 'timestamp',
      Fecha_Pago: 'date',
    }, reverse)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Bancos/Pagos.js